import { Link } from "react-router-dom";

export function LogoMark({ size = 24, color = "#0A0A0A" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" data-testid="nimbly-logo-mark">
      <path d="M7.5 25V12.5a4.25 4.25 0 0 1 8.5 0v7a4.25 4.25 0 0 0 8.5 0V7.5" stroke={color} strokeWidth="4.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Logo({ to = "/", dark = false, size = 24 }) {
  return (
    <Link to={to} className="flex items-center gap-2 shrink-0" data-testid="nimbly-logo">
      <LogoMark size={size} color={dark ? "#FFFFFF" : "#0A0A0A"} />
      <span className={`font-display font-bold text-[19px] tracking-tight ${dark ? "text-white" : "text-[#0A0A0A]"}`}>nimbly</span>
    </Link>
  );
}
